import React from 'react';
import { useAgents } from '../../hooks/useAgents';

function AgentSelector({ selectedAgentId, onSelect }) {
  const { agentsBySquad, squadOrder } = useAgents();

  return (
    <div className="chat-agent-bar">
      <button className="chat-mobile-toggle" aria-label="Menu">
        &#9776;
      </button>
      <label className="chat-agent-label">Agente:</label>
      <select
        className="chat-agent-select"
        value={selectedAgentId}
        onChange={(e) => onSelect(e.target.value)}
      >
        {squadOrder.map(squad => (
          <optgroup key={squad} label={squad}>
            {agentsBySquad[squad]?.map(agent => (
              <option key={agent.id} value={agent.id}>
                {agent.icon} {agent.name} — {agent.title}
                {agent.id === 'orquestrador' ? ' (Recomendado)' : ''}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {selectedAgentId === 'orquestrador' && (
        <span className="chat-agent-recommended">Recomendado</span>
      )}
    </div>
  );
}

export default AgentSelector;
